import { Invoice } from "@lib/types/Billing";
import { Drawer } from "antd";
import useIntl from "react-intl/lib/src/components/useIntl";
import { FormattedMessage } from "react-intl";
import InvoiceComponent from "@lib/components/MiniComponents/Invoice";
import { Customer } from "@lib/types/Customer";
import { useTypedSelector } from "@lib/redux";
import { AuthRoles } from "@lib/types";
import { useMemo } from "react";

type Props = {
  openDrawer: boolean;
  toggleDrawer: (status?: boolean) => void;
  invoice?: Invoice;
  setSelectedInvoice: (invoice: Invoice) => void;
  invoiceListQueryKey: string[];
  customer?: Customer;
  tabToBeOpenedOnFooter?: string;
};

export default function InvoiceDrawer(props: Props) {
  const {
    openDrawer,
    toggleDrawer,
    invoice,
    setSelectedInvoice,
    invoiceListQueryKey,
    customer,
    tabToBeOpenedOnFooter,
  } = props;
  const { messages } = useIntl();
  const { role } = useTypedSelector((state) => state.auth.user);
  const isEditMode = role === AuthRoles.Admin;

  const title = useMemo(() => {
    if (!isEditMode) return "common.previewTitle";
    if (invoice) {
      return "common.editTitle";
    }
    return "common.createTitle";
  }, [invoice, isEditMode]);

  return (
    <>
      <Drawer
        title={
          <FormattedMessage
            id={title}
            values={{ title: messages["common.invoice"] as string }}
          />
        }
        onClose={() => toggleDrawer(!openDrawer)}
        open={openDrawer}
        width={800}
        id="invoice-drawer"
        styles={{
          body: {
            padding: 0,
          },
        }}
      >
        <InvoiceComponent
          open={openDrawer}
          invoice={invoice}
          setSelectedInvoice={setSelectedInvoice}
          invoiceListQueryKey={invoiceListQueryKey}
          customer={customer}
          tabToBeOpenedOnFooter={tabToBeOpenedOnFooter}
          isEditMode={isEditMode}
        />
      </Drawer>
    </>
  );
}
